import { FC } from 'react';
import PresentationModal from '../../organisms/PresentationModal';

interface ParsePayloadModalProps {
    id: string;
    show: boolean;
    payload: string;
    onChange: (value: string) => void;
    onParse: () => void;
    onClose: () => void;
}

const ParsePayloadModal: FC<ParsePayloadModalProps> = ({ id, show, payload, onChange, onParse, onClose }) => {
    return (
        <PresentationModal id={id} show={show} onClose={onClose} header="Parser de Payload" height="400px">
            <div className="p-4 space-y-4">
                <textarea
                    className="w-full border border-gray-300 rounded p-2"
                    rows={8}
                    value={payload}
                    placeholder="Cole o payload JSON aqui..."
                    onChange={(e) => onChange(e.target.value)}
                />
                <div className="flex justify-end space-x-2">
                    <button
                        className="text-black bg-slate-200 px-4 py-2 rounded hover:bg-slate-400"
                        onClick={onClose}
                    >
                        Cancelar
                    </button>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-800"
                        onClick={onParse}
                    >
                        Extrair
                    </button>
                </div>
            </div>
        </PresentationModal>
    );
};

export default ParsePayloadModal;
